import { array } from 'io-ts/Decoder';

import { iotsUtils } from '@bedc/core';

export const Request = <T extends string>(fieldNames: readonly T[]) =>
	array(iotsUtils.fromList(fieldNames));
